

export const ronBio = {
  _id: 'ronBioId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  aboutMe: [
    `The Mirror of Erised says I'm headboy, quidditch captain, and better than all my brothers... you can decide if it's true or not`,
    `Quidditch keeper, Wizard Chess maestro, and clumsiest potion maker in Hogwarts history`,
    `Lover of chocolate frogs and hijinx, but with a Jack Russell Terrier Patronus`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `My pet rat Scabbers!`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Weekends in Hogsmead and the Quidditch World Cup`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Is it a good thing when your sister dates your best friend?`,
    }
  ],
  hobbies: [
    `Quidditch`,
    `Pranks`,
    `Parties`,
    `Weekend Getaways`,
    `Butterbeer`
  ],
  vitalInfo: {
    firstName: `Ron`, 
    age: 18,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 70,
    heightCM: 178,
    inOrCmPreference: 'in',
    currentCity: `Hogsmead`,
    hometown: `London`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Hogwarts`,
    profession: `General Manager`,
    employer: `Professional Quidditch Team`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Dog'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const hermioneBio = {
  _id: 'hermioneBioId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  aboutMe: [
    `The most mischevious teacher's pet you've ever hated in the classroom and loved outside of it`,
    `Do you really love me or is it the Amortentia kicking in`,
    `Serious on the surface, but don't worry, my Patronus is an otter`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who can beat me in Wizard Chess`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sitting in the front row and raising my hand immediately whenever the teacher asks a question`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Apparitioning or portkeys?`,
    }
  ],
  hobbies: [
    `History`,
    `Potions`,
    `Camping`,
    `Butterbeer`,
    `Festivals`
  ],
  vitalInfo: {
    firstName: `Hermione`, 
    age: 19,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 67,
    heightCM: 170,
    inOrCmPreference: 'in',
    currentCity: `Hogsmead`,
    hometown: `London`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Hogwarts`,
    profession: `Minister`,
    employer: `Ministry of Magic`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const harryBio = {
  _id: 'harryBioId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  aboutMe: [
    `Parseltongue, but in a good way`,
    `Quiddich seeker in pursuit of the snitch for my heart`,
    `Not a hairy ceramicist`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A lightning bolt for my heart... already got one on my forehead`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sneaking around with the Marauder's Map in my invisibility cloak`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite thing that flies — dragons, owls, or broomsticks?`,
    }
  ],
  hobbies: [
    `Quidditch`,
    `Camping`,
    `Parties`,
    `Dueling`,
    `Friends`
  ],
  vitalInfo: {
    firstName: `Harry`, 
    age: 20,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 70,
    heightCM: 178,
    inOrCmPreference: 'cm',
    currentCity: `Hogsmead`,
    hometown: `London`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Hogwarts`,
    profession: `Auror`,
    employer: `Ministry of Magic`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const dumbledoreBio = {
  _id: 'dumbledoreBioId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  aboutMe: [
    `Not a dumb door, but isn't that what a dumb door would say...`,
    `Headmaster? Yes. Head master? Perhaps you'll find out`,
    `Holder of the Elder Wand, and also of the eldest... wand`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A chocolate frog that disappeared in my beard two months ago`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Counting all of my wrinkles`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Ravenclaw or Hufflepuff?`,
    }
  ],
  hobbies: [
    `History`,
    `Restaurants`,
    `Travel`,
    `Philosophy`,
    `Longevity`
  ],
  vitalInfo: {
    firstName: `Albus`, 
    age: 189,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Gay',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 74,
    heightCM: 185,
    inOrCmPreference: 'in',
    currentCity: `Hogsmead`,
    hometown: `London`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Hogwarts`,
    profession: `Headmaster`,
    employer: `Hogwarts`,
    children: `Don't have children`,
    familyPlans: `Don't want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}